import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "person-frame",
  "use": "person-frame-usage",
  "viewBox": "0 0 25 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 24\" id=\"person-frame\"><path d=\"M9.111 6.531a6.858 6.858 0 007.643 1.536\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path clip-rule=\"evenodd\" d=\"M12.666 12.75a4.125 4.125 0 100-8.25 4.125 4.125 0 000 8.25z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M1.416 6.751V2.25a1.5 1.5 0 011.5-1.5h4.5M23.916 6.751V2.25a1.5 1.5 0 00-1.5-1.5h-4.5M1.416 17.25v4.5a1.5 1.5 0 001.5 1.5h4.5M23.916 17.25v4.5a1.5 1.5 0 01-1.5 1.5h-4.5M19.002 18.75a6.712 6.712 0 00-12.674 0\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/person-frame.svg
// module id = 5KkW
// module chunks = 39 44